<template>
    <div id="app">
        <b-container>
        <Header></Header>
        <router-view :key="$route.fullPath"></router-view>
        </b-container>
    </div>
</template>

<script>
import Header from '@/view/header';
export default {
    name: 'app',
    components: {
        'Header':Header
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.container, .container-lg, .container-md, .container-sm, .container-xl{
    max-width: 1200px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue